<div [ngStyle]="{'visibility': omitRow ? 'hidden' : 'visible'}" class="intent-editor">
  <button
    #button
    pButton
    type="button"
    (click)="toggleValue()"
    [attr.tabindex]="!editingEnabled? -1:null"
    [label]="isBuy ? 'Buy' : 'Sell'"
    icon="bfx-icon icon-swap_horiz"
    iconPos="right"
    [ngClass]="{
          'bfx-button-oe-sell':!isBuy,
          'bfx-button-oe-buy': isBuy,
          'interface-control__client-intent-toggle__intent-button': true,
          'interface-control__client-intent-toggle__intent-button--sell':!isBuy,
          'interface-control__client-intent-toggle__intent-button--buy': isBuy
   }"
  ></button>
</div>
